import { useEffect, useRef, useState } from 'react';
import { useClickOutside } from 'hooks/click-outside';
import styles from './new-album-modal.module.scss';

interface NewAlbumModalProps {
  // Called with the entered album name when the user confirms.
  onSubmit: (name: string) => void;
  onClose: () => void;
}

export const NewAlbumModal = ({ onSubmit, onClose }: NewAlbumModalProps) => {
  const [name, setName] = useState('');
  const cardRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useClickOutside(cardRef, onClose);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const trimmed = name.trim();

  const submit = () => {
    if (!trimmed) return;
    onSubmit(trimmed);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      submit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      onClose();
    }
  };

  return (
    <div className={styles.backdrop}>
      <div className={styles.card} ref={cardRef}>
        <span className={styles.title}>New Album</span>
        <input
          ref={inputRef}
          type="text"
          className={styles.input}
          value={name}
          placeholder="Album name"
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.createButton}
            onClick={submit}
            disabled={!trimmed}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};
